import { VenueListNotificationsFilter, VenueNotification } from '../../graphql/API';
import { venueListNotifications } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueListNotificationsApi = async (
  filter: VenueListNotificationsFilter,
): Promise<VenueNotification[]> => {
  const result = await executeGql<VenueNotification[]>(venueListNotifications, { filter });
  return processGqlResult<VenueNotification[]>('venueListNotifications.items', result) ?? [];
};
